import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/manager/')({
  beforeLoad: () => {
    console.log("Redirecting from /manager to /manager/dashboard");
    throw redirect({ to: '/manager/dashboard', replace: true });
  }
});
